import { setSigninTracking } from '@cencosud-cencommerce/paris-login';

import { BrazeSigninTrackingAdapter } from './signinTracking.adapter';

let injected = false;

export function injectSigninTrackingAdapter() {
  if (injected) return;

  if (!window?.braze) return;

  setSigninTracking(new BrazeSigninTrackingAdapter());
  injected = true;

  console.info('[Braze] SigninTrackingAdapter injected');
}
